import axios from "axios";
import { API_URL, getHeader } from "../config";

export const getHighlight = async () => {
  const { data } = await axios.get(API_URL + `/api/highlight/FAJUNIORSB`);
  return data;
};

export const getNews = async () => {
  const { data } = await axios.get(API_URL + `/api/news/FAJUNIORSB`);
  return data;
};

export const getNewsInner = async () => {
  const { data } = await axios.get(API_URL + `/api/news/all/FAJUNIORSB`);
  return data;
};

export const getEvents = async () => {
  const { data } = await axios.get(API_URL + `/api/events/FAJUNIORSB`);
  return data;
};

export const getEventsinner = async () => {
  const { data } = await axios.get(API_URL + `/api/events/All/FAJUNIORSB`);
  return data;
};

export const getGallery = async () => {
  const { data } = await axios.get(API_URL + `/api/gallery/FAJUNIORSB`);
  return data;
};

export const getGalleryInner = async () => {
  const { data } = await axios.get(API_URL + `/api/gallery/All/FAJUNIORSB`);
  return data;
};

export const getSubGallery = async (id) => {
  const { data } = await axios.get(API_URL + `/api/subGallery?id=${id}`);
  return data;
};

export const getNotification = async () => {
  const { data } = await axios.get(
    API_URL + `/api/notification/FAJUNIORSB`,
    getHeader()
  );
  return data;
};

export const getTopper = async () => {
  const { data } = await axios.get(API_URL + `/api/topper/FAJUNIORSB`, getHeader());
  return data;
};

export const getOnlineRegistration = async () => {
  const { data } = await axios.get(
    API_URL + `/api/onlineRegistration/FAJUNIORSB`,
    getHeader()
  );
  return data;
};

export const getPrincipalMessage = async () => {
  const { data } = await axios.get(
    API_URL + `/api/principalMessage/FAJUNIORSB`,
    getHeader()
  );
  return data;
};

export const getVideo = async () => {
  const { data } = await axios.get(API_URL + `/api/video/All/FAJUNIORSB`);
  return data;
};

export const postTransferCertificate = async (name, admission) => {
  const { data } = await axios.post(
    API_URL + `/api/tc/FAJUNIORSB`,
    { name, admission },
    getHeader()
  );
  return data;
};

export const form1 = async (formData, header, type) => {
  try {
    const { data } = await axios.post(
      `${API_URL}/api/form/FAJUNIORSB/${type}`,
      formData,
      header
    );
    console.log(data);
    return data;
  } catch (error) {
    console.error("Error in form submission:", error);
    if (error.response) {
      console.error("Error response data:", error.response.data);
    }
    throw error;
  }
};

export const academicCalender = async () => {
  const { data } = await axios.get(
    API_URL + `/api/academicCalender/all/FAJUNIORSB`,
    getHeader()
  );
  console.log("academic calender", data);
  return data;
};

export const getBirthdays = async () => {
  const { data } = await axios.get(API_URL + `/api/birthdays/FAJUNIORSB`);
  console.log(data);
  return data;
};
